import { Button, Col, Input, Modal, Row, Select } from 'antd'
import { useEffect, useState } from 'react'
import './PercentageStatusDialog.style.less'

function PercentageStatusDialog(props: {
  visible: boolean
  onClose: () => any
  onSet: (value: any) => any
  current_progress: any
}) {
  const [status, setStatus] = useState(1)
  const [valuePercent, setValuePercent] = useState(1)

  useEffect(() => {
    if (!props.current_progress) {
      setStatus(2)
    }
  }, [])

  const _setValue = () => {
    if (status === 1) props.onSet('planned')
    else props.onSet(valuePercent)
    props.onClose()
  }

  const onChangePercentage = (e) => {
    if (isNaN(e.target.value as any)) {
      setValuePercent(0)
      return
    }
    if (Number(e.target.value) > 100) return
    setValuePercent(Number(e.target.value))
  }

  return (
    <Modal
      className="dialog-set-plan"
      title="Set Progress Status"
      open={props.visible}
      onCancel={() => {
        props.onClose()
      }}
      footer={[
        <Button key={'dummy'} />,
        <Button
          className="default-dialog-button"
          shape="round"
          type="primary"
          size="large"
          key={'set'}
          onClick={() => {
            _setValue()
          }}
        >
          Set
        </Button>,
      ]}
    >
      <div className="">
        <Row gutter={[16, 16]} align="middle">
          <Col md={6} lg={6}>
            <label style={{ fontWeight: 500 }}>Current Status</label>
          </Col>
          <Col md={18} lg={18}>
            <Select
              allowClear
              value={status}
              style={{ width: '100%' }}
              onChange={(value) => setStatus(value)}
            >
              {props.current_progress && (
                <Select.Option value={1}>Planned</Select.Option>
              )}
              <Select.Option value={2}>Input Percent</Select.Option>
            </Select>
          </Col>
        </Row>
        <br />
        {status === 2 && (
          <Row gutter={[16, 0]} align="middle">
            <Col md={6} lg={6} className="mt-3">
              <label style={{ fontWeight: 500 }}>Percentage</label>
            </Col>
            <Col md={18} lg={18}>
              <Input
                className="br-1 input-fat-1 input-right"
                suffix="%"
                size="large"
                onChange={(e) => onChangePercentage(e)}
                value={valuePercent}
              />
            </Col>
          </Row>
        )}
      </div>
    </Modal>
  )
}

export default PercentageStatusDialog
